export const hasNumber = (value) => typeof value === "number" && Number.isFinite(value);

export function formatNumber(value, language = "ru", digits = 0) {
  if (!hasNumber(value)) return "—";
  const locale = { kz: "kk", cn: "zh" }[language] || language;
  return new Intl.NumberFormat(locale, { maximumFractionDigits: digits }).format(value);
}

export function formatDateInput(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function getInitialPeriod() {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - 29);
  return { startDate: formatDateInput(start), endDate: formatDateInput(end) };
}

export const validRows = (rows) =>
  Array.isArray(rows) ? rows.filter((row) => row && typeof row === "object") : [];
